import {IPaymentMethodsBannerProps} from '@wix/wixstores-client-storefront-sdk/dist/src/viewer-script/wixcode/payments/getPaymentMethodsBannerProps';
import {createBlocksModel} from '@wix/yoshi-flow-editor';

export default createBlocksModel({
  widgetName: 'priceWidget',
  props: {
    formattedActualPrice: {
      type: undefined,
      defaultValue: undefined as string | undefined,
    },
    formattedOriginalPrice: {
      type: undefined,
      defaultValue: undefined as string | undefined,
    },
    formattedPricePerUnit: {
      type: undefined,
      defaultValue: undefined as string | undefined,
    },
    formattedUnitAndQuantity: {
      type: undefined,
      defaultValue: undefined as string | undefined,
    },
    srFormattedUnitAndQuantity: {
      type: undefined,
      defaultValue: undefined as string | undefined,
    },
    frequencyLabel: {
      type: undefined,
      defaultValue: undefined as string | undefined,
    },
    showPriceRange: {
      type: 'boolean',
      defaultValue: false,
    },
    showPricePerUnit: {
      type: 'boolean',
      defaultValue: false,
    },
    showDiscount: {
      type: 'boolean',
      defaultValue: false,
    },
    showTaxDisclaimer: {
      type: 'boolean',
      defaultValue: false,
    },
    taxDisclaimerText: {
      type: undefined,
      defaultValue: undefined as string | undefined,
    },
    showShippingDisclaimer: {
      type: 'boolean',
      defaultValue: false,
    },
    showShippingDisclaimerModal: {
      type: 'boolean',
      defaultValue: false,
    },
    shippingDisclaimerText: {
      type: undefined,
      defaultValue: undefined as string | undefined,
    },
    cashierBannerProps: {
      type: undefined,
      defaultValue: null as unknown as IPaymentMethodsBannerProps,
    },
    showDiscountTitle: {
      type: 'boolean',
      defaultValue: false,
    },
    discountTitle: {
      type: undefined,
      defaultValue: undefined as string | undefined,
    },
  },
  methods: {},
  events: {},
});
